var UiNotificationHelper = function (externalOptions, dependencies) {
	'use strict';

	var backendUrls = {};
	var backendTexts = {};

	var defaultOptions = {
		isStartPage: false,
	};

	var options = $.extend(defaultOptions, externalOptions);

	var DOM_SELECTORS = {
		containers: {

		},
		buttons: {

		},
	}

	var methods = {
		init: function () {
			initInternal();
		},
		backend: {
			urls: {
				set: {
					confirmAsRead: function (url) {
						backendUrls['confirmAsRead'] = url;
					},
					download: function (url) {
						backendUrls['download'] = url;
					},
					getInitDataByUser: function (url) {
						backendUrls['getInitDataByUser'] = url;
					},
					getByUser: function (url) {
						backendUrls['getByUser'] = url;
					},
					updateStatusToOpened: function (url) {
						backendUrls['updateStatusToOpened'] = url;
					},
				},
				get: {
					confirmAsRead: function () {
						return backendUrls['confirmAsRead'];
					},
					download: function () {
						return backendUrls['download'];
					},
					getInitDataByUser: function () {
						return backendUrls['getInitDataByUser'];
					},
					getByUser: function () {
						return backendUrls['getByUser'];
					},
					updateStatusToOpened: function () {
						return backendUrls['updateStatusToOpened'];
					},
				},
			},
			texts: {
				set: {
					notifications: function (text) {
						backendTexts['notifications'] = text;
					},
					close: function (text) {
						backendTexts['close'] = text;
					},
					confirmed: function (text) {
						backendTexts['confirmed'] = text;
					},
					whereToFindUploadedDocuments: function (text) {
						backendTexts['whereToFindUploadedDocuments'] = text;
					},
					downloadDocument: function (text) {
						backendTexts['downloadDocument'] = text;
					},
					confirmDocumentAsRead: function (text) {
						backendTexts['confirmDocumentAsRead'] = text;
					},
					loading: function (text) {
						backendTexts['loading'] = text;
					},
					pleaseWait: function (text) {
						backendTexts['pleaseWait'] = text;
					},
					fileNotFound: function (text) {
						backendTexts['fileNotFound'] = text;
					},
				},
				get: {
					notifications: function () {
						return backendTexts['notifications'];
					},
					close: function () {
						return backendTexts['close'];
					},
					confirmed: function () {
						return backendTexts['confirmed'];
					},
					whereToFindUploadedDocuments: function () {
						return backendTexts['whereToFindUploadedDocuments'];
					},
					downloadDocument: function () {
						return backendTexts['downloadDocument'];
					},
					confirmDocumentAsRead: function () {
						return backendTexts['confirmDocumentAsRead'];
					},
					loading: function () {
						return backendTexts['loading'];
					},
					pleaseWait: function () {
						return backendTexts['pleaseWait'];
					},
					fileNotFound: function () {
						return backendTexts['fileNotFound'];
					}

				},
			},
		},

	}

	var internalMethods = {
		ui: {
			setCount: function (count) {
				var $notificationContainer = $('#user-notification-container');
				var $button = $notificationContainer.find('a#show-ui-notifications .badge');
				$notificationContainer.find('.badge').text(count);

				if (count == 0) {
					$button.removeClass('badge-warning');
					$button.removeClass('has-notifications');
					$button.addClass('badge-dark');
				} else {
					$button.removeClass('badge-dark');
					$button.addClass('badge-warning');
					$button.addClass('has-notifications');
				}
			},
			getCount: function () {
				return Number($('#user-notification-container .badge').text());
			},
			reduceCountBy: function (subtractValue, $notificationContainer) {
				if ($notificationContainer.hasClass('downloaded') == false) {
					$notificationContainer.addClass('downloaded');

					var current = internalMethods.ui.getCount();
					internalMethods.ui.setCount(current - subtractValue);
				}
			},
			showModal: function () {
				var waitDialog = internalMethods.ui.showWaitDialog();

				internalMethods.ajax.getNotifications().done(function (uiNotifications) {
					setTimeout(function () {
						waitDialog.close();
					}, 500);
					show(uiNotifications);
				});

				function show(uiNotifications) {
					var ops = getModalOptions(uiNotifications);
					var modal = new BootstrapDialog(ops);
					modal.realize();
					modal.open();

					function getModalOptions(uiNotifications) {
						return {
							title: methods.backend.texts.get.notifications(),
							size: BootstrapDialog.SIZE_WIDE,
							closable: true,
							draggable: true,
							autodestroy: true,
							nl2br: false,
							onshow: function (me) {
								var $body = me.getModalBody().find('.bootstrap-dialog-message');
								buildBody($body, uiNotifications);
							},
							buttons: [{
								id: 'close',
								label: methods.backend.texts.get.close(),
								cssClass: 'btn-primary',
								action: function (me) {
									me.close();
								}
							}]
						};
					}

					function buildBody($body, uiNotifications) {

						Object.keys(uiNotifications).forEach(function (key) {
							var $row = buildRow(uiNotifications[key]);
							$body.append($row);

						});

						var $reminder = $('<div id="document-location-reminder"><span>' + methods.backend.texts.get.whereToFindUploadedDocuments() + '</span></div>');
						$body.append($reminder);

						function buildRow(uiNotification) {
							var fileExists = typeof (uiNotification.FileUrl) != 'undefined';
							var $container = $(`<p class="notification-container" data-document-id="${uiNotification.DocumentId}" data-user-notification-id="${uiNotification.UiNotificationdocumentXumuserId}"></p>`);
							appendHeader($container, uiNotification);
							appendBody($container, uiNotification, fileExists);
							appendFooter($container, uiNotification, fileExists);
							return $container;

							function appendHeader($container, uiNotification) {
								var $header = $(`<div class="notification-header">
											${uiNotification.Title}
											</div>`);
								$container.append($header);
							}

							function appendBody($container, uiNotification, fileExists) {

								var warningMessage = fileExists ? '' : '  <i class="text-warning fal fa-exclamation-triangle" data-toggle="tooltip" title="' + methods.backend.texts.get.fileNotFound() + '"/>';;

								var $body = $(`<div class="notification-body-container">
											<div class="notification-body">${uiNotification.Body + (fileExists ? '' : warningMessage)}</div>
										  </div>`);
								$container.append($body);
							}

							function appendFooter($container, uiNotification, fileExists) {
								var downloadDocumentLabel = methods.backend.texts.get.downloadDocument();
								var url = uiNotification.FileUrl;
								var $footer = $('<div class="notification-footer"></div>');

								if (!fileExists) {
									$footer.append($('<button class="btn btn-secondary remove-notification">The file does not exists anymore, remove notification</button>'));
									$container.append($footer);
									return;
								}

								var $anchor = $(dependencies.ju2.grid.ui.formatLinkToAnchor(url, uiNotification.DocumentFileName));
								var $actionButton = $(`<button class="btn btn-secondary download-document" ${fileExists ? '' : 'disabled'}>${fileExists ? downloadDocumentLabel : methods.backend.texts.get.fileNotFound()}</button>`);


								$anchor.html($actionButton);
								$footer.append($anchor);

								if (uiNotification.IsConfirmationRequired == true) {
									var confirmDocumentAsReadLabel = methods.backend.texts.get.confirmDocumentAsRead();
									var disabledAttribute = uiNotification.Status == '3100' ? 'disabled' : '';
									var $confirmReadButton = $(`<button class="btn btn-success confirm-read-notification" ${disabledAttribute}>${confirmDocumentAsReadLabel}</button>`);
									$footer.append($confirmReadButton);
								};

								$container.append($footer);
							}
						}
					}
				}
			},
			showWaitDialog: function ($button) {
				var title = methods.backend.texts.get.loading();
				var message = methods.backend.texts.get.pleaseWait();
				var waitDialog = dependencies.ju2.bootstrapDialog.showWaitDialog(title, message, true, $button);
				return waitDialog;
			}
		},
		ajax: {
			confirmAsRead: function (userNotificationId) {
				return $.ajax({
					type: 'POST',
					url: methods.backend.urls.get.confirmAsRead(),
					data: {
						userNotificationId: userNotificationId,
					},
				}).done(function (xhr) {

				}).fail(function (xhr) {
					dependencies.ju2.notification.resetNotifys();
					dependencies.ju2.notification.showNotifyError(xhr);
				});
			},
			getInitDataByUser: function () {
				return $.ajax({
					contentType: 'application/json; charset=utf-8',
					dataType: 'json',
					type: 'GET',
					url: methods.backend.urls.get.getInitDataByUser(),
				}).done(function (initData) {
					return initData;
				}).fail(function () {

				});
			},
			getNotifications: function () {
				return $.ajax({
					contentType: 'application/json; charset=utf-8',
					dataType: 'json',
					type: 'GET',
					url: methods.backend.urls.get.getByUser(),
				}).done(function (notifications) {

				}).fail(function () {

				});
			},
			updateStatusToOpened: function (userNotificationId) {
				return $.ajax({
					type: 'POST',
					url: methods.backend.urls.get.updateStatusToOpened(),
					data: {
						userNotificationId: userNotificationId,
					},
				}).done(function () {

				}).fail(function () {

				});
			},
		}
	};

	function initInternal() {
		getInitDataByUser();
		attachListeners();

		function attachListeners() {
			$('#show-ui-notifications').on('click', function () {
				internalMethods.ui.showModal();
			});

			$(document).on('click', '.download-document', function () {
				var $button = $(this)
					, userNotificationId = getUserNotificationId($button)
					, $notificationContainer = $button.parents('.notification-container')
					, $footer = $button.parents('.notification-footer');

				var $confirmationButton = $footer.find('.confirm-read-notification');
				if ($confirmationButton.length == 1 && $notificationContainer.hasClass('confirmed') == false) {
					$confirmationButton.prop('disabled', false);
				} else {
					internalMethods.ui.reduceCountBy(1, $notificationContainer);
				}

				internalMethods.ajax.updateStatusToOpened(userNotificationId);
			});

			$(document).on('click', '.confirm-read-notification', function () {
				var $button = $(this)
					, $notificationContainer = $button.parents('.notification-container')
					, userNotificationId = getUserNotificationId($button);

				if ($notificationContainer.hasClass('confirmed' == true)) {
					return;
				}

				internalMethods.ajax.confirmAsRead(userNotificationId).done(function () {
					$button.attr('disabled', true);
					$button.text(methods.backend.texts.get.confirmed());
					$notificationContainer.addClass('confirmed');
					internalMethods.ui.reduceCountBy(1, $notificationContainer);
				});
			});

			$(document).on('click', '.remove-notification', function () {
				var $button = $(this)
					, $notificationContainer = $button.parents('.notification-container')
					, userNotificationId = getUserNotificationId($button);

				internalMethods.ajax.confirmAsRead(userNotificationId).done(function () {
					$button.attr('disabled', true);
					internalMethods.ui.reduceCountBy(1, $notificationContainer);
				});
			});

			function getUserNotificationId($button) {
				var $container = $button.parents('.notification-container');
				return $container.data('userNotificationId');
			}
		}

		function getInitDataByUser() {
			internalMethods.ajax.getInitDataByUser().done(function (count) {

				internalMethods.ui.setCount(count);

				if (isAutoOpen(count)) {
					internalMethods.ui.showModal();
				}

				function isAutoOpen(count) {
					return count > 0 & options.isStartPage == true;
				}
			});
		}
	}

	return methods;
};

// Export as a module for other imports, but also attach to `window` for global use
globalThis.UiNotificationHelper = UiNotificationHelper;
export default UiNotificationHelper;